<template>

<v-dialog v-model="dialog" width="600px">
  <v-card>
    <v-card-title>
      Negative balance to credits
    </v-card-title>
    <v-card-text>
      <v-row no-gutters class="black--text mt-4">
        This booking is showing a balance of {{ hklr.booking_balance }}. Add {{ hklr.credits_amount }} in guest credits to bring the balance to zero.
      </v-row>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="primary mx-2" small @click="saveCredits">Add</v-btn>
      <v-btn color="primary"  small @click="dialog = false">Close</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  data() { 
    return {
      dialog: false,
      addHklrNegativeBalanceToCredits: false,
      huov_encrid: null,
      hklr_nr: '',
      hklr_bedrag: null,
      huov_code_moveto: null,
      hklr_nrKeuzes: [],
      hklr: {},
    }
  },
  methods: {
    open(huov_encrid) {
      this.$emit("showSnackbar");
      this.dialog = true;
      this.huov_encrid = huov_encrid;
      this.hklr_nrKeuzes.length = 0;
      this.hklr_dt = '';
      this.hklr_bedrag = '';
      this.hklr_nr = '';
      this.$axios
        .post("ares/json/ares/huov/hklr/getHklrDataToAddCredits.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHuovToAddCredits"
          },
          getHuovToAddCredits: {
            huov_encrid: huov_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
            this.loading = false;
          } else {
            
            this.hklr = res.data.getHuovToAddCredits;
            console.log('hklr', this.hklr);
            this.loading = false;
          }
        })

    },
    saveCredits() {
      // Save cancellation insurance logic here
      this.$axios
        .post("ares/json/ares/huov/hklr/addHklrNegativeBalanceToCredits.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "addHklrNegativeBalanceToCredits"
          },
          addHklrNegativeBalanceToCredits: {
            huov_encrid: this.huov_encrid,
            credits_amount_dec: this.hklr.credits_amount_dec
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
            this.loading = false;
          } else {
            setTimeout(() => { this.$router.reload('/huov/onHuov/' + this.huov_encrid); }, 2000);
            this.$store.dispatch('setSnackbar', {
                showing: true,
                text: 'Credits created successfully.',
                color: 'success'
            });             
            this.loading = false;
            this.dialog = false;
          }
        })      
    }
  }
}
</script>

